export const DEFAULT_WEEKDAY_DELIVERY_DAYS = ['mon', 'tue', 'wed', 'thu', 'fri']

export const MIN_ORDER_POUNDS_PLACEHOLDER = '0'

export const MIN_ORDER_POUNDS_HELPER_TEXT =
  'Enter the minimum order in pounds. Leave blank for £0.'

export const getEmptySupplierCreateForm = () => ({
  title: '',
  secondTitle: '',
  emailAddress: '',
  accountNumber: '',
  vendorCode: '',
  minOrderValue: '',
  deliveryDays: [...DEFAULT_WEEKDAY_DELIVERY_DAYS],
  phoneNumber: '',
  orderCutOffTime: '',
  orderCutOffInstructions: '',
  logoUrl: '',
  secondEmailAddresses: [],
})

export const poundsToMinOrderPence = value => {
  if (value === null || value === undefined) return 0

  const normalized = String(value).trim()
  if (!normalized) return 0

  const pounds = Number(normalized)
  if (!Number.isFinite(pounds) || pounds < 0) return null

  return Math.round(pounds * 100)
}

export const isValidMinOrderPoundsInput = value => {
  if (value === null || value === undefined) return true

  const normalized = String(value).trim()
  if (!normalized) return true

  const pounds = Number(normalized)
  return Number.isFinite(pounds) && pounds >= 0
}

export const OPTIONAL_SUPPLIER_CREATE_STRING_FIELDS = [
  'vendorCode',
  'integrationType',
  'ironWebAgreementNumber',
  'dc',
  'orderCutOffTime',
  'orderCutOffInstructions',
]

export const stripEmptyOptionalSupplierFields = supplier => {
  const payload = { ...supplier }

  OPTIONAL_SUPPLIER_CREATE_STRING_FIELDS.forEach(field => {
    if (!payload[field]) {
      delete payload[field]
    }
  })

  return payload
}

export const prepareSupplierCreatePayload = supplier => {
  const minOrderValue = poundsToMinOrderPence(supplier.minOrderValue)

  return stripEmptyOptionalSupplierFields({
    ...supplier,
    minOrderValue: minOrderValue === null ? 0 : minOrderValue,
    deliveryDays:
      supplier.deliveryDays?.length > 0
        ? supplier.deliveryDays
        : [...DEFAULT_WEEKDAY_DELIVERY_DAYS],
  })
}

/** Map ant Design create-form field values to the supplier API payload shape. */
export const mapSupplierCreateFormValues = values => ({
  title: values.title?.trim() || '',
  secondTitle: values.secondTitle?.trim() || '',
  emailAddress: values.emailAddress?.trim() || '',
  phoneNumber: values.phoneNumber?.trim() || '',
  accountNumber: values.accountNumber?.trim() || '',
  minOrderValue: values.minOrderValue ?? '',
  deliveryDays: values.deliveryDays || [],
  orderCutOffTime: values.orderCutOffTime || '',
  orderCutOffInstructions: values.orderCutOffInstructions?.trim() || '',
  logoUrl: values.logoUrl?.trim() || '',
  secondEmailAddresses: values.secondEmailAddresses || [],
  integrationType: values.integrationType?.trim() || '',
  ironWebAgreementNumber:
    String(values.integrationType || '')
      .trim()
      .toLowerCase() === 'ironweb'
      ? values.ironWebAgreementNumber?.trim() || ''
      : '',
  vendorCode: values.vendorCode?.trim() || '',
  dc: values.dc?.trim() || '',
})

export const normalizeSupplierMatchText = value =>
  String(value || '')
    .trim()
    .toLowerCase()

export const supplierTitleKey = (title, secondTitle) =>
  `${normalizeSupplierMatchText(title)}::${normalizeSupplierMatchText(
    secondTitle,
  )}`

export const findDuplicateSupplier = (suppliers, title, secondTitle) => {
  const targetKey = supplierTitleKey(title, secondTitle)

  return (
    (suppliers || []).find(
      supplier =>
        supplierTitleKey(supplier.title, supplier.secondTitle) === targetKey,
    ) || null
  )
}

export const getDuplicateSupplierErrorMessage = (title, secondTitle) =>
  `A supplier named "${title}" with price list "${secondTitle}" already exists. Use a different supplier name or price list name.`
